var map = {
	"./banner2.jpg": "WPQK",
	"./bg1.jpg": "GaTJ",
	"./bg2.jpg": "ShSX",
	"./contact_us_1.jpg": "aIZC",
	"./contact_us_2.jpg": "xU/o",
	"./footer.jpg": "o+P5",
	"./footer1.jpg": "9Q4M",
	"./index10.jpg": "4koJ",
	"./index9.jpg": "9aPN",
	"./index_bg.jpg": "ol0V",
	"./index_bg_1.jpg": "fOB5",
	"./index_bg_11.jpg": "F5FM",
	"./index_bg_2.jpg": "yqmj",
	"./index_bg_3.jpg": "4CKf",
	"./index_bg_5.jpg": "0GDD",
	"./index_bg_6.jpg": "4edx",
	"./index_bg_7.jpg": "LnWs",
	"./index_bg_8.jpg": "R6dU",
	"./page-header.jpg": "BLCG",
	"./pattrick1-bg.jpg": "pV4h",
	"./service1.jpg": "sE2O",
	"./service2.jpg": "Qxly",
	"./service3.jpg": "DCT9",
	"./sing-name.jpg": "6r7g",
	"./slider-2.jpg": "HqNB",
	"./team1.jpg": "6cqv",
	"./wrapper-library.jpg": "t8Lf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JDml";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg ^\.\/.*\.jpg$
// module id = JDml
// module chunks = 9